import { render, staticRenderFns } from "./AlertEditor.vue?vue&type=template&id=67857651&scoped=true&"
import script from "./AlertEditor.vue?vue&type=script&lang=js&"
export * from "./AlertEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67857651",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VSelect})
